import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "help",
  "use": "help-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"help\"><path d=\"M10 1.4a8.6 8.6 0 1 1 0 17.2 8.6 8.6 0 0 1 0-17.2ZM10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z\" /><path d=\"M8.9 12.1h1.7v-.5c0-1.5 2.4-1.8 2.4-4.1 0-1.7-1.4-2.6-3-2.6-1.7 0-2.7 1-2.7 1l1 1.2s.7-.6 1.5-.6 1.4.5 1.4 1.2c0 1.4-2.3 1.7-2.3 3.8v.6Zm0 2.9h1.7v-1.7H8.9V15Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol